import ClientPortalImageUpload from "./ClientPortalImageUpload";

const VENDOR_TYPES = [
  "Realtor",
  "Broker",
  "Photographer",
  "Property Manager",
  "Contractor",
  "Legal",
  "Lender",
  "Inspector",
  "Appraiser",
  "Other",
];

export const EMPTY_VENDOR_FORM = {
  vendorName: "",
  vendorType: "Realtor",
  website: "",
  photoUrl: "",
  phone: "",
  email: "",
  notes: "",
};

function VendorFormModal({
  title,
  form,
  setForm,
  onSubmit,
  onClose,
  saving,
  error,
  submitLabel,
  clientViewId,
  vendorId,
}) {
  return (
    <div className="client-vendor-modal-backdrop" onClick={onClose}>
      <div
        className="client-vendor-modal"
        role="dialog"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="client-vendor-modal-header">
          <h3>{title}</h3>
          <button type="button" className="cv-button-link" onClick={onClose}>
            Close
          </button>
        </div>
        <form className="client-vendor-modal-form" onSubmit={onSubmit}>
          {error ? <p className="admin-data-health-error">{error}</p> : null}
          <label className="admin-users-field">
            <span>Name</span>
            <input
              type="text"
              required
              value={form.vendorName}
              onChange={(e) => setForm((f) => ({ ...f, vendorName: e.target.value }))}
              placeholder="Full name or business name"
            />
          </label>
          <label className="admin-users-field">
            <span>Type</span>
            <select
              value={form.vendorType}
              onChange={(e) => setForm((f) => ({ ...f, vendorType: e.target.value }))}
            >
              {VENDOR_TYPES.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </label>
          <label className="admin-users-field">
            <span>Email</span>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              placeholder="contact@example.com"
            />
          </label>
          <label className="admin-users-field">
            <span>Phone</span>
            <input
              type="tel"
              value={form.phone}
              onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value }))}
              placeholder="(702) 555-0100"
            />
          </label>
          <label className="admin-users-field">
            <span>Website</span>
            <input
              type="url"
              value={form.website}
              onChange={(e) => setForm((f) => ({ ...f, website: e.target.value }))}
              placeholder="https://"
            />
          </label>
          {clientViewId ? (
            <ClientPortalImageUpload
              clientViewId={clientViewId}
              kind="vendor_photo"
              entityId={vendorId}
              label="Profile photo"
              hint="Square headshots work best. JPG, PNG, or WebP up to 8MB."
              value={form.photoUrl}
              onChange={(photoUrl) => setForm((f) => ({ ...f, photoUrl }))}
            />
          ) : (
            <label className="admin-users-field">
              <span>Profile photo URL</span>
              <input
                type="url"
                value={form.photoUrl}
                onChange={(e) => setForm((f) => ({ ...f, photoUrl: e.target.value }))}
                placeholder="https://example.com/photo.jpg"
              />
            </label>
          )}
          <label className="admin-users-field">
            <span>Notes</span>
            <textarea
              rows={3}
              value={form.notes}
              onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
              placeholder="Specialty, notes, or additional info…"
            />
          </label>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving…" : submitLabel}
          </button>
        </form>
      </div>
    </div>
  );
}

export default VendorFormModal;
